import axiosInstance from "./axios-instance";

export interface RosterStudent {
  id: number;
  name: string;
  has_pin: boolean;
}

export interface ClassRoster {
  class_name: string | null;
  school_name: string | null;
  /** Off for a normal class: the class code plus your own name is the sign-in. */
  requires_pin: boolean;
  students: RosterStudent[];
}

export interface TeacherRosterStudent extends RosterStudent {
  is_locked: boolean;
}

export interface TeacherClassRoster {
  class_name: string | null;
  class_code: string | null;
  school_name: string | null;
  requires_pin: boolean;
  students: TeacherRosterStudent[];
}

/** Student flow: roster for a class code, so a child can pick their name. */
export const getClassRoster = async (classCode: string): Promise<ClassRoster> => {
  const response = await axiosInstance.post(
    `/login/class/${encodeURIComponent(classCode)}`
  );
  return response.data;
};

/** Normal class: no personal code, just the class code and your own name. */
export const loginAsClassStudent = async (params: {
  student_id: number;
  class_code: string;
}): Promise<{ token: string }> => {
  const response = await axiosInstance.post("/login/student", params);
  return response.data;
};

export const loginWithPin = async (params: {
  student_id: number;
  class_code: string;
  pin: string;
}): Promise<{ token: string }> => {
  const response = await axiosInstance.post("/login/pin", params);
  return response.data;
};

export const setStudentPin = async (params: {
  student_id: number;
  class_code: string;
  pin: string;
}): Promise<{ token: string }> => {
  const response = await axiosInstance.post("/login/pin/set", params);
  return response.data;
};

/** Teacher flow. */
export const getTeacherClassRoster = async (
  gradeId: number
): Promise<TeacherClassRoster> => {
  const response = await axiosInstance.get(`/teacher/class/${gradeId}/roster`);
  return response.data;
};

export const resetStudentPin = async (
  gradeId: number,
  studentId: number
): Promise<{ message: string }> => {
  const response = await axiosInstance.post(
    `/teacher/class/${gradeId}/reset-pin`,
    { student_id: studentId }
  );
  return response.data;
};

export const regenerateClassCode = async (
  gradeId: number
): Promise<{ class_code: string }> => {
  const response = await axiosInstance.post(
    `/teacher/class/${gradeId}/regenerate-code`
  );
  return response.data;
};
